import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LogoutIcon } from "../assets/icons.constants";
import "./login-popover.component.scss";
export default function LoginPopover(props) {
  const [t] = useTranslation();
  const history = useHistory();
  const pageData = {
    loginOrRegister: t("loginPage.loginOrRegister", "Login / Register"),
  };
  return (
    <a href="/login" className="login_content_theme1">
      <LogoutIcon className="icon" />
      <div className="title">{pageData.loginOrRegister}</div>
    </a>
  );
}
